/* eslint-disable consistent-return */

/**
 * Since we cannot import our npm lib, we manually port the validator function from that lib here
 */
export default (validationRules = {}, value = '') => {
  const validators = Object.keys(validationRules);
  let valid = true;

  try {
    for (let i = 0; i < validators.length; i++) {
      const validator = validators[i];
      const criteria = validationRules[validator];

      switch (validator) {
        case 'required':
          if (validationRules[validator]
          && (value === '' || value === null || value === undefined)) {
            valid = false;
          }
          break;
        case 'minLength':
          if (value.length < criteria) valid = false;
          break;

        case 'maxLength':
          if (value.length > criteria) valid = false;
          break;

        case 'minChoice':
          if (value.length < criteria) valid = false;
          break;

        case 'maxChoice':
          if (value.length > criteria) valid = false;
          break;

        case 'minNumber':
          if (value < criteria) valid = false;
          break;

        case 'maxNumber':
          if (value > criteria) valid = false;
          break;

        case 'regex':
          // a field can be "not required" but still have regex rule
          if (validationRules.required === false && value === '') {
            break;
          }

          if (!(new RegExp(criteria).test(value))) valid = false;
          break;

        default:
          break;
      }
    }

    return valid;
  } catch (e) {
    console.error(e)
  }
};



// WEBPACK FOOTER //
// ./src/features/common/util/validator.js